import React from 'react';
import DialogContentTextMui from '@material-ui/core/DialogContentText';
import { DialogContentTextProps } from '@material-ui/core';

export const DialogContentText: React.FC<DialogContentTextProps> = ({ children, ...rest }) => {
	return <DialogContentTextMui {...rest}>{children}</DialogContentTextMui>;
};
